import { initLayout } from '../layout.js';

document.addEventListener('DOMContentLoaded', () => {
    initLayout();
})
